import { StageDataField } from '@Components/Flows';
import { useGetPurchase } from '../../../hooks/usePurchases';

const discountTypeObj = {
  PERCENTAGE: '%',
  FLATAMOUNT: 'off',
  PRICEOVERRIDE: 'Price Override',
};

export function StageContentShopPurchase({ stage }) {
  const purchaseId = stage?.result?.responseDataBindings?.[0];

  const { data: purchase } = useGetPurchase(purchaseId, {
    include: 'eventType,venue,status,spaces',
  });

  const purchaseProductDescription = purchase?.productDescription ?? 'N/A';
  const purchaseCreatedAt = purchase?.createdAt ?? 'N/A';
  const purchaseConfirmationNumber = purchase?.confirmationNumber ?? 'N/A';
  const purchaseOriginalPrice = purchase?.originalPrice?.toString() ?? 'N/A';
  const purchaseDiscountAmount = purchase?.discountAmount ?? 'N/A';
  const purchaseDiscountType = purchase?.discountType ?? 'N/A';
  const purchasePrice = purchase?.price?.toString() ?? 'N/A';

  const discount =
    purchaseDiscountAmount && purchaseDiscountType
      ? `${purchaseDiscountAmount} ${discountTypeObj[purchaseDiscountType]}`
      : 'N/A';

  return (
    <div className="flex flex-col gap-3">
      <div className="break-word w-1/2">
        <StageDataField
          label={'Purchase Description'}
          value={purchaseProductDescription}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Purchase Date'} value={purchaseCreatedAt} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Purchase Confirmation Number'}
          value={purchaseConfirmationNumber}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Original Price'}
          value={purchaseOriginalPrice}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Discount'} value={discount} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Purchase Price'} value={purchasePrice} />
      </div>
    </div>
  );
}
